'use client';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { PRIVACY_URL, TERMS_URL } from '@/constants/links';
import { PRODUCT } from '@/constants/product';
import { CheckIcon } from '@/icons';
import { PROFESSIONAL_USE_LABEL } from './constants';
import { classes } from './utils';

export interface ConsentGateProps {
  acceptsTerms: boolean;
  isProfessional: boolean;
  className?: string;
  onToggleProfessional: () => void;
  onToggleTerms: () => void;
}

// Bespoke box: needs a full-width hit area and links inside the label.
export default function ConsentGate({
  acceptsTerms,
  className,
  isProfessional,
  onToggleProfessional,
  onToggleTerms,
}: ConsentGateProps) {
  const renderRow = (
    checked: boolean,
    label: ReactNode,
    rowClassName: string,
    onToggle: () => void
  ) => (
    <div
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      className={twMerge(classes.row, rowClassName)}
      onClick={onToggle}>
      <span
        className={twMerge(
          classes.box,
          checked ? classes.boxChecked : classes.boxUnchecked
        )}>
        <CheckIcon
          size={12}
          strokeWidth={3.2}
          className={twMerge(
            classes.tick,
            checked ? classes.tickChecked : classes.tickUnchecked
          )}
        />
      </span>
      <span className={classes.label}>{label}</span>
    </div>
  );

  const termsLabel = (
    <>
      I accept the{' '}
      <a href={TERMS_URL} className={classes.link}>
        Terms &amp; Conditions
      </a>{' '}
      and{' '}
      <a href={PRIVACY_URL} className={classes.link}>
        Privacy Policy
      </a>
      .
    </>
  );

  return (
    <div className={twMerge(classes.block, className)}>
      <p className={classes.notice}>{PRODUCT.deviceNotice}</p>
      {renderRow(
        isProfessional,
        PROFESSIONAL_USE_LABEL,
        classes.firstRow,
        onToggleProfessional
      )}
      {renderRow(acceptsTerms, termsLabel, classes.secondRow, onToggleTerms)}
    </div>
  );
}
